export enum InitialResult {
  DEFAULT,
  NO_REPLY,
  POSITIVE,
  NEGATIVE,
}
